import script from "./SearchCoreInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchCoreInput.vue?vue&type=script&setup=true&lang=ts"

import "./SearchCoreInput.vue?vue&type=style&index=0&id=c4e4a816&lang=scss"

const __exports__ = script;

export default __exports__